import React, { memo, useEffect, useState } from "react"
import AOS from "aos"
import parse from "html-react-parser"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import Quote from "../../svg/new/quote"
import "aos/dist/aos.css"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import { replaceUnderscoresWithSpaces } from "../../../utils/functions"
import CommonModal from "../../../Common/new/modal"
import * as style from "./testimonials.module.css"

const Testimonials = ({
  CustomClass,
  homeTestimonialsViewAllLink,
  homeTestimonialsContent,
  homeTestimonialsTitle,
  homeTestimonialsShowSection,
  homeTestimonialsSubTitle,
  testimonialList,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  const [isModalOpen, setModalOpen] = useState(false)
  const [modalVideo, setModalVideo] = useState({})

  const handleClickVideo = (item) => {
    if (item?.TestimonialsField?.videoLink) {
      setModalOpen(true)
    }
    setModalVideo(item)
  }

  return (
    <>
      {homeTestimonialsShowSection === "yes" && (
        <section
          className={`${style.testimonials} ${CustomClass}`}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className="row flex-wrap">
              <div className={style.testimonials_wrap}>
                <SectionsTitle
                  title={replaceUnderscoresWithSpaces(homeTestimonialsTitle)}
                  SubTitle={homeTestimonialsSubTitle}
                  Content={homeTestimonialsContent}
                  styleCss={{ display: "none" }}
                />
              </div>
            </div>
            <div className={style.testimonials_listing}>
              <Swiper
                spaceBetween={30}
                centeredSlides={false}
                slidesPerView={2}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                  },
                  1200: {
                    slidesPerView: 2,
                  },
                }}
                className={`${style.testimonial_swiper} mySwiper`}
              >
                {testimonialList?.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div className={style.testimonials_info}>
                        <div className={style.user_info_wrap}>
                          <div
                            className={`${style.testimonials_image_wrap} ${item?.TestimonialsField?.videoLink ? style.video_icon : ''}`}
                            style={item?.TestimonialsField?.videoLink && { cursor: 'pointer' }}
                            onClick={() => handleClickVideo(item)}
                          >
                            <OptimizedImage
                              imageData={
                                item?.featuredImage?.node?.mediaItemUrl
                                  ? item?.featuredImage?.node?.mediaItemUrl
                                  : "/images/placeholder-image.jpg"
                              }
                              alt={item?.featuredImage?.node?.altText}
                            />
                          </div>
                          <div className={style.user_details_wrap}>
                            <p className={style.user_name}>{item?.title}</p>
                            <p className={style.other_details}>
                              {item?.TestimonialsField?.position}
                            </p>
                            <p className={style.other_details}>
                              {item?.TestimonialsField?.country}
                            </p>
                          </div>
                        </div>
                        <div className={style.testimonial_desc}>
                          <div className={style.quote_wrap}>
                            <Quote />
                          </div>
                          <p>{parse(`${item?.TestimonialsField?.feedback}`)}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          </div>
          <CommonModal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
            <div className="video-box">
              {modalVideo?.TestimonialsField?.videoLink ? (
                <video controls>
                  <source
                    src={
                      modalVideo?.TestimonialsField?.videoLink?.mediaItemUrl
                    }
                    type="video/mp4"
                  />
                </video>
              ) : (
                "no videos"
              )}
            </div>
          </CommonModal>
        </section >
      )}
    </>
  )
}

export default memo(Testimonials)
